/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Checkbox } from "@mui/material";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { AiFillCalendar } from "react-icons/ai";
import { IoLocationSharp } from "react-icons/io5";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import DetailBlock from "../../common/DetailBlock";
import LabelInput from "../../common/LabelInput";
import LabelText from "../../common/LabelText";
import Body from "../../components/Body";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { getOrganizationByid } from "../../stores/OrganizationStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLocations } from "../../stores/LocationStore";
import { getContractById } from "../../stores/ContractStore";

const checkList_1_init = [
  {
    name: "Clean all the entrance areas and lobby",
    value: "Daily",
    checked: false,
  },
  {
    name: "Vacuum carpeted Areas",
    value: "Weekly/As needed",
    checked: false,
  },
  {
    name: "Elevator area complete cleaning",
    value: "Daily",
    checked: false,
  },
  {
    name: "Garbage chute area complete cleaning",
    value: "Daily",
    checked: false,
  },
  {
    name: "Sweep and mop the floors [Laundry Rooms, Lobby, and Hallways & Stains",
    value: "Daily",
    checked: false,
  },
  {
    name: "Clean the washer and dryer",
    value: "Daily or Bi weekly",
    checked: false,
  },
  {
    name: "Sweep and remove soil and or leave in the entrance area",
    value: "Daily",
    checked: false,
  },
  {
    name: "Clean and dust of all areas (light, post Boxes, Entrance Areas, inside doors Areas Heaters & Inside Windows",
    value: "weekly or as needed",
    checked: false,
  },
  {
    name: "Inside windows",
    value: "weekly or as needed",
    checked: false,
  },
  {
    name: "Spot cleaning the high contract areas such as walls, entrance doors and baseboards",
    value: "As needed",
    checked: false,
  },
  {
    name: "Clean dust stair-banister",
    value: "Weekly or as needed",
    checked: false,
  },
  {
    name: "Report unusual incident, damage or malfunction",
    value: "",
    checked: false,
  },
];

const checkList_2_init = [
  {
    name: "Client agrees to provide cleaning materials and equipment needed for the performance of these duties",
    value:
      "Client agrees to provide cleaning materials and equipment needed for the performance of these duties",
    checked: false,
  },
  {
    name: "Contractor agrees to provide cleaning materials and equipment needed for the performance of these duties",
    value:
      "Contractor agrees to provide cleaning materials and equipment needed for the performance of these duties",
    checked: false,
  },
];

function ContractsEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: init } = location?.state;
  const queryClient = useQueryClient();

  const { data: contract = {} } = useQuery({
    queryFn: () => getContractById(init?._id),
    queryKey: ["contract", init?._id],
  });

  const { data: organization = {} } = useQuery({
    queryFn: () => getOrganizationByid(contract.organization),
    queryKey: ["organization", contract.organization],
    enabled: !!contract.organization,
  });

  const { data: locationsData } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  // Initialize listOne from contract data or defaults
  const [listOne, setListOne] = useState([]);
  const [listTwo, setListTwo] = useState([]);
  const [form, setForm] = useState({});

  // Initialize lists when contract data is loaded
  useEffect(() => {
    if (contract?._id && contract?.checkListOne) {
      // Merge contract data with defaults, preserving contract data
      const merged = checkList_1_init.map((defaultItem) => {
        const contractItem = contract.checkListOne.find(
          (i) => i.name === defaultItem.name
        );
        return contractItem || defaultItem;
      });

      // Add any custom items from contract that aren't in defaults
      const customItems = contract.checkListOne.filter(
        (contractItem) =>
          !checkList_1_init.find((i) => i.name === contractItem.name)
      );

      setListOne([...merged, ...customItems]);

      if (contract.checkListTwo) {
        const merged2 = checkList_2_init.map((defaultItem) => {
          const contractItem = contract.checkListTwo.find(
            (i) => i.name === defaultItem.name
          );
          return contractItem || defaultItem;
        });
        setListTwo(merged2);
      }
    }
  }, [contract?._id]);

  // Update form when contract and organization data is loaded
  useEffect(() => {
    if (contract?._id && organization?._id) {
      const loca =
        contract.location
          ?.map((loc) => {
            const found = locationsData?.find((item) => item._id === loc);
            if (found) {
              return { ...found, name: `${found.tag} - ${found.title}` };
            }
            return found;
          })
          .filter(Boolean) || [];

          setForm({
        ...contract,
        organization: organization,
        organizationName: organization?.name,
        poRequestLocation: organization?.billingAddress,
        agreementDate: new Date(contract.agreementDate),
        contractStartDate: new Date(contract.contractStartDate),
        contractEndDate: new Date(contract.contractEndDate),
        location: loca,
      });
    }
  }, [contract?._id, organization?._id, locationsData]);

  const handleSubmit = async (event) => {
    const frm = {
      ...form,
      organization: organization?._id,
      location: form.location?.map((loc) => loc._id),
      checkListOne: listOne
        .filter((i) => i.checked)
        .map((i) => ({ ...i, value: i.value === i.name ? "" : i.value })),
      checkListTwo: listTwo
        .filter((i) => i.checked)
        .map((i) => ({ ...i, value: i.value === i.name ? "" : i.value })),
    };

    const res = await api.put("/contracts", frm);
    if (res.ok) {
      queryClient.invalidateQueries(["contracts"]);
      toast.success("Contract has been successfully updated.");
      navigate(
        `/organizations/view/${organization?._id}/contract/${contract._id}`,
        {
          state: { data: { ...cloneDeep(form), ...(contract || {}) } },
        }
      );
    } else {
      return toast.error(res.originalError.message);
    }
  };

  const handleChange = ({ target }) => {
    const name = target.name;
    const value = target.value;
    if (name === "jobStartDate") {
      if (new Date(form.jobEndDate).valueOf() < new Date(value).valueOf()) {
        delete form.jobEndDate;
      }
    }
    setForm({ ...form, [name]: value });
  };

  const handleSelect = ({ target }) => {
    const name = target.name;
    const value = target.value;
    setForm({
      ...form,
      [name]: value,
      attention: value?.length ? `${value[0]?.incharge}\n${value[0]?.tag}` : "",
    });
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure want to delete the contract?") === false)
      return false;

    const res = await api.put("/contracts", { _id: form._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["contracts"]);

    toast.success("Contract has been successfully deleted");
    navigate(`/organizations/contracts/${organization?._id}`, {
      state: { data: cloneDeep(organization) },
    });
  };

  const {
    contractId: jobId,
    poRequestLocation,
    agreementDate,
    jobStartDate: contractStartDate,
    jobEndDate: contractEndDate,
    tax,
    attention,
    helpText,
    location: loc,
    noPo,
  } = form;

  const size = config.iconSize;
  const locations = organization?.locations?.map((loc) => {
    const found = locationsData?.find((item) => item._id === loc);
    return found;
  });

  // Add more handler for listOne
  const handleAddMore = () => {
    setListOne((list) => [
      ...list,
      {
        name: "",
        value: "",
        checked: false,
        editableTitle: true,
      },
    ]);
  };

  // Updated handlers to work with listOne directly
  const handleChangeTitle_one = (ind, value) => {
    const newList = [...listOne];
    newList[ind] = { ...newList[ind], name: value };
    setListOne(newList);
  };

  const handleChangeTitle_two = (ind, value) => {
    const newList = [...listTwo];
    newList[ind] = { ...newList[ind], name: value };
    setListTwo(newList);
  };

  const handleChangeChecklist_one = (ind, event) => {
    const { value } = event.target;
    const newList = [...listOne];
    newList[ind] = {
      ...newList[ind],
      value,
    };
    setListOne(newList);
  };

  const handleChangeChecklist_two = (ind, event) => {
    const { value } = event.target;
    const newList = [...listTwo];
    newList[ind] = {
      ...newList[ind],
      value,
    };
    setListTwo(newList);
  };

  const handleCheked_one = (ind, checked) => {
    const newList = [...listOne];
    newList[ind] = { ...newList[ind], checked };
    setListOne(newList);
  };

  const handleCheked_two = (ind, checked) => {
    const newList = [...listTwo];
    newList[ind] = { ...newList[ind], checked };
    setListTwo(newList);
  };

  return (
    <Body title="Edit Contract">
      <form onSubmit={handleSubmit} noValidate={false}>
        <div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <DetailBlock
              style={{
                boxShadow: "none",
                width: "100%",
                backgroundColor: "transparent",
              }}
            >
              <div
                className="d-flex"
                style={{
                  justifyContent: "space-between",
                  marginBottom: 30,
                }}
              >
                <LabelText columnMode label="Contract ID" value={jobId} />
                <LabelText
                  columnMode
                  label="Client"
                  value={organization?.name}
                />
                <LabelText
                  columnMode
                  label="PO Request Location"
                  value={poRequestLocation}
                />
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div className="d-flex justify-content-center">
                <div
                  className="d-flex"
                  style={{
                    width: 800,
                    flexWrap: "wrap",
                    gap: "0px 40px",
                    justifyContent: "center",
                    marginBottom: 30,
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "space-between",
                      width: 800,
                      gap: 20,
                    }}
                  >
                    <AppInput
                      type="date"
                      label="Agreement Date"
                      onChange={handleChange}
                      name="agreementDate"
                      placeholder="Agreement Date"
                      value={agreementDate}
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                      floatLabel
                      required
                    />
                    <AppInput
                      onChange={handleChange}
                      name="contractStartDate"
                      label="Contract Start Date"
                      datePicker
                      floatLabel
                      value={form.contractStartDate}
                      required
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                    <AppInput
                      onChange={handleChange}
                      name="contractEndDate"
                      label="Contract End Date"
                      placeholder="Contract End Date"
                      datePicker
                      minDate={contractStartDate}
                      value={form.contractEndDate}
                      required
                      floatLabel
                      type="date"
                      leftIcon={
                        <AiFillCalendar
                          color={colors.silver}
                          size={config.iconSize}
                        />
                      }
                    />
                  </div>
                  <AppInput
                    type="multi"
                    label="Job Location"
                    name="location"
                    chip
                    onChange={handleSelect}
                    leftIcon={<IoLocationSharp size={size} color={"silver"} />}
                    style={{ width: 800 }}
                    options={locations
                      ?.filter((i) => i !== undefined)
                      ?.map((i) => {
                        return {
                          ...i,
                          name: `${i.tag} - ${i.title}`,
                        };
                      })}
                    filterBy="name"
                    value={loc}
                    required
                    floatLabel
                  />

                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "space-between",
                      width: 800,
                      gap: 20,
                    }}
                  >
                    <AppInput
                      name="working_days_in_a_week"
                      label="Day of work in a week"
                      floatLabel
                      onChange={handleChange}
                      value={form.working_days_in_a_week}
                    />
                    <AppInput
                      name="working_hours_in_a_week"
                      label="Working hours in a week"
                      floatLabel
                      onChange={handleChange}
                      value={form.working_hours_in_a_week}
                    />
                    <AppInput
                      onChange={handleChange}
                      name="monthly_payment_cost"
                      label="Monthly payment cost"
                      value={form.monthly_payment_cost}
                      floatLabel
                    />
                  </div>
                </div>
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div>
                <LabelInput
                  onChange={handleChange}
                  forceLabel={<b>Invoice Detail</b>}
                  multiline
                  name="invoice_text"
                  style={{ maxWidth: "100%", minHeight: 100 }}
                  value={form.invoice_text}
                />
              </div>
            </DetailBlock>
            <DetailBlock style={{ width: "100%" }}>
              <div>
                <h5 style={{ fontWeight: "bolder" }}>Client Signing details</h5>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>
                      Name of the Authorized Signing Officer :
                    </label>
                    <AppInput
                      label="Name"
                      autoFocus
                      name="clientName"
                      onChange={handleChange}
                      floatLabel
                      value={form.clientName}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>Designation : </label>
                    <AppInput
                      label="Designation"
                      autoFocus
                      name="clientDesignation"
                      onChange={handleChange}
                      floatLabel
                      value={form.clientDesignation}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                </div>
              </div>
              <br />
              <div>
                <h5 style={{ fontWeight: "bolder" }}>
                  Signing Details of A2Z Professional Cleaning & Maintenance
                  Inc.
                </h5>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>
                      Name of the Authorized Signing Officer :
                    </label>
                    <AppInput
                      label="Name"
                      autoFocus
                      name="contractorName"
                      onChange={handleChange}
                      floatLabel
                      value={form.contractorName}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label style={{ width: 550 }}>Designation : </label>
                    <AppInput
                      label="Designation"
                      autoFocus
                      name="contractorDesignation"
                      onChange={handleChange}
                      floatLabel
                      value={form.contractorDesignation}
                      inputType="text"
                      required
                      style={{ width: 550 }}
                    />
                  </div>
                </div>
              </div>
            </DetailBlock>

            <DetailBlock style={{ width: 1200 }}>
              {listOne.map((dt, ind) => {
                return (
                  <CheckListItem
                    onChange={(event) => handleChangeChecklist_one(ind, event)}
                    onChangeTitle={(value) => handleChangeTitle_one(ind, value)}
                    onChecked={(value) => handleCheked_one(ind, value)}
                    key={ind}
                    ind={ind}
                    checked={dt.checked}
                    {...dt}
                  />
                );
              })}
              <AppButton
                text="Add More"
                type="button"
                onClick={handleAddMore}
              />
            </DetailBlock>

            <DetailBlock style={{ width: "100%" }}>
              {listTwo.map((dt, ind) => {
                return (
                  <CheckListItem
                    onChange={(event) => handleChangeChecklist_two(ind, event)}
                    onChangeTitle={(value) => handleChangeTitle_two(ind, value)}
                    onChecked={(value) => handleCheked_two(ind, value)}
                    key={ind}
                    ind={ind}
                    extra={false}
                    {...dt}
                  />
                );
              })}
            </DetailBlock>
          </div>

          <div className="d-flex" style={{ margin: "20px 0px", gap: 10 }}>
            <AppButton
              type="button"
              onClick={handleSubmit}
              text="Save"
              className="btn-primary"
            />

            <AppButton
              type="button"
              onClick={handleDelete}
              text="Delete"
              className="btn-danger"
            />
          </div>
        </div>
      </form>
    </Body>
  );
}

const CheckListItem = ({
  value,
  onChange,
  name,
  onChecked,
  editableTitle,
  height = 60,
  onChangeTitle,
  checked,
  extra = true,
}) => {
  const [enabled, setEnabled] = useState(checked);

  useEffect(() => {
    setEnabled(checked);
  }, [checked]);

  return (
    <div className="d-flex align-items-center">
      <div>
        <Checkbox
          onClick={() => {
            const newEnabled = !enabled;
            setEnabled(newEnabled);
            if (onChecked) {
              onChecked(newEnabled);
            }
          }}
          checked={enabled}
        />
      </div>
      <AppInput
        onChange={(event) => {
          if (onChangeTitle) {
            onChangeTitle(event.target.value);
          }
        }}
        disabled={!enabled}
        value={name}
        readOnly={!editableTitle}
        multiline
        type="textArea"
        style={{
          border: "none",
          resize: "none",
          height: height,
          backgroundColor: "#00000010",
          overflow: "hidden",
        }}
      />
      <div style={{ width: 200, visibility: extra ? "visible" : "hidden" }}>
        <AppInput
          autoFocus={enabled}
          onChange={onChange}
          disabled={!enabled}
          placeholder="(                  )"
          style={{ height: height }}
          value={value}
        />
      </div>
    </div>
  );
};

export default observer(ContractsEdit);
